import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Category color palette (from design guidelines)
export const CATEGORY_STYLES = {
  pdf:        { light: "bg-rose-50 text-rose-600",     dark: "dark:bg-rose-950/40 dark:text-rose-300",   ring: "ring-rose-200 dark:ring-rose-900",     dot: "bg-rose-500" },
  image:      { light: "bg-amber-50 text-amber-700",   dark: "dark:bg-amber-950/40 dark:text-amber-300", ring: "ring-amber-200 dark:ring-amber-900",   dot: "bg-amber-500" },
  word:       { light: "bg-blue-50 text-blue-700",     dark: "dark:bg-blue-950/40 dark:text-blue-300",   ring: "ring-blue-200 dark:ring-blue-900",     dot: "bg-blue-500" },
  excel:      { light: "bg-emerald-50 text-emerald-700", dark: "dark:bg-emerald-950/40 dark:text-emerald-300", ring: "ring-emerald-200 dark:ring-emerald-900", dot: "bg-emerald-500" },
  powerpoint: { light: "bg-orange-50 text-orange-700", dark: "dark:bg-orange-950/40 dark:text-orange-300", ring: "ring-orange-200 dark:ring-orange-900", dot: "bg-orange-500" },
  ai:         { light: "bg-zinc-100 text-zinc-900",    dark: "dark:bg-zinc-800 dark:text-zinc-100",      ring: "ring-zinc-300 dark:ring-zinc-700",     dot: "bg-zinc-900 dark:bg-zinc-200" },
  ocr:        { light: "bg-violet-50 text-violet-700", dark: "dark:bg-violet-950/40 dark:text-violet-300", ring: "ring-violet-200 dark:ring-violet-900", dot: "bg-violet-500" },
  security:   { light: "bg-slate-100 text-slate-700",  dark: "dark:bg-slate-800 dark:text-slate-200",    ring: "ring-slate-300 dark:ring-slate-700",   dot: "bg-slate-500" },
};

export function catStyle(cat) {
  const s = CATEGORY_STYLES[cat] || CATEGORY_STYLES.security;
  return `${s.light} ${s.dark}`;
}
export function catDot(cat) {
  return (CATEGORY_STYLES[cat] || CATEGORY_STYLES.security).dot;
}
